define('app-Brochures/main',['./settings'], function (settings) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('No "Brochures" Container found.  brochures will not be available.');
                return;
            }

            $('.brochure-list').slideDown();

            if ($('.brochure-list').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".brochure.active").offset().top
                });
            }

            window.loadedModules("app-Brochures");
        }
    }
});



